const cache = new Map();

export function img(src) {
  let e = cache.get(src);
  if (!e) {
    e = new Image();
    e.decoding = "async";
    e.src = src;
    cache.set(src, e);
  }
  return e.complete && e.naturalWidth > 0 ? e : null;
}

export function preload(srcs) {
  srcs.forEach((s) => img(s));
}

export function imgPadBottom(im) {
  if (im._padB != null) return im._padB;
  try {
    const c2 = document.createElement("canvas"); c2.width = im.naturalWidth; c2.height = 1;
    const x2 = c2.getContext("2d");
    let padT = 0, padP = 0;
    for (let y = im.naturalHeight - 1; y >= 0; y--) {
      x2.clearRect(0, 0, c2.width, 1); x2.drawImage(im, 0, y, im.naturalWidth, 1, 0, 0, im.naturalWidth, 1);
      const row = x2.getImageData(0, 0, im.naturalWidth, 1).data; let n = 0, tot = 0;
      for (let i = 3; i < row.length; i += 16) { tot++; if (row[i] > 40) n++; }
      if (n / tot >= 0.5) break;
      if (n === 0) padT++; else padP++;
      if (padT + padP > im.naturalHeight * 0.3) break;
    }
    const pad = padT + (padP <= im.naturalHeight * 0.08 ? padP : 0);
    im._padB = pad / im.naturalHeight;
  } catch { im._padB = 0; }
  return im._padB;
}

export const DUCK_FRAMES = [0, 1, 2, 3, 4].map((i) => `/game/duck_walk_${i}.webp`);
export const DUCK_PORTRAIT = "/game/duck_portrait.webp";
export const DUCK_HERO = "/game/duck_hero.webp";
export const DUCK_FRONT = "/game/duck_front.webp";
